import axios from "axios";
import { createContext, useContext, useReducer } from "react";
import Form_reducer from "../reducer/Form_reducer";
import Notification from "../utils/Notification";
import {
  GET_CONTACT_US_BEGIN,
  GET_CONTACT_US_SUCCESS,
  GET_CONTACT_US_ERROR,
  GET_REGISTER_FORM_BEGIN,
  GET_REGISTER_FORM_SUCCESS,
  GET_REGISTER_FORM_ERROR,
  GET_REGISTER_DETAIL_EXPO_BEGIN,
  GET_REGISTER_DETAIL_EXPO_SUCCESS,
  GET_REGISTER_DETAIL_EXPO_ERROR,
  POST_EXPO_CONTACT_US_BEGIN,
  POST_EXPO_CONTACT_US_SUCCESS,
  POST_EXPO_CONTACT_US_ERROR,
  GET_VISITOR_FORMAT_BEGIN,
  GET_VISITOR_FORMAT_SUCCESS,
  GET_VISITOR_FORMAT_ERROR,
  SUBMIT_DOMESTIC_VISITOR_BEGIN,
  SUBMIT_DOMESTIC_VISITOR_SUCCESS,
  SUBMIT_DOMESTIC_VISITOR_ERROR,
  SUBMIT_INTERNATIONAL_VISITOR_BEGIN,
  SUBMIT_INTERNATIONAL_VISITOR_SUCCESS,
  SUBMIT_INTERNATIONAL_VISITOR_ERROR,
  SUBMIT_EXHIBITOR_BEGIN,
  SUBMIT_EXHIBITOR_SUCCESS,
  SUBMIT_EXHIBITOR_ERROR,
} from "../utils/action";
import {
  ACCEPT_HEADER,
  get_contact_us_url,
  get_register_form_url,
  get_register_detail_expo_url,
  expo_contact_us_url,
  visitor_format_url,
  submit_domestic_visitor_url,
  submit_international_visitor_url,
  submit_exhibitor_visitor_url,
} from "../utils/constant";

// ─── Meta Pixel Purchase Event Tracker ─────────────────────────────────────
const trackMetaPurchase = () => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    try {
      window.fbq("track", "Purchase", { currency: "USD", value: 30.00 });
    } catch (e) {
      console.error("Meta Pixel tracking error:", e);
    }
  }
};

const FormContext = createContext();

const initialState = {
  contact_us_loading: false,
  contact_us_data: {},
  expo_contact_us_loading: false,
  register_form_loading: false,
  register_form_data: {},
  register_detail_expo_loading: false,
  register_detail_expo_data: {},
  visitor_format_loading: false,
  visitor_format_data: {},
  submit_domestic_visitor_loading: false,
  submit_international_visitor_loading: false,
  submit_exhibitor_loading: false,
};

export const FormProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Form_reducer, initialState);

  // ─── GET CONTACT US ─────────────────────────────────────────────────────────
  const GetContactUs = async () => {
    dispatch({ type: GET_CONTACT_US_BEGIN });

    axios
      .get(get_contact_us_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_CONTACT_US_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_CONTACT_US_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Contact Us Api ", err);
        dispatch({ type: GET_CONTACT_US_ERROR });
      });
  };

  // ─── POST EXPO CONTACT US ───────────────────────────────────────────────────
  const PostExpoContactUs = async (formdata) => {
    dispatch({ type: POST_EXPO_CONTACT_US_BEGIN });

    axios
      .post(expo_contact_us_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: POST_EXPO_CONTACT_US_SUCCESS });
          Notification(
            "success",
            "Success",
            res.data.message,
          );
          trackMetaPurchase();
        } else {
          dispatch({ type: POST_EXPO_CONTACT_US_ERROR });
          Notification(
            "error",
            "Error",
            res.data.message,
          );
        }
      })
      .catch((err) => {
        console.log("Error in Post Expo Contact Us Api ", err);
        dispatch({ type: POST_EXPO_CONTACT_US_ERROR });
        Notification(
          "error",
          "Error",
          err.response?.data?.message,
        );
      });
  };

  // ─── GET REGISTER FORM ──────────────────────────────────────────────────────
  const GetRegisterForm = async () => {
    dispatch({ type: GET_REGISTER_FORM_BEGIN });

    axios
      .get(get_register_form_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_REGISTER_FORM_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_REGISTER_FORM_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Register Form Api ", err);
        dispatch({ type: GET_REGISTER_FORM_ERROR });
      });
  };

  // ─── GET REGISTER DETAIL EXPO (POST with registration_category_id) ─────────
  const GetRegisterDetailExpo = async (categoryId) => {
    dispatch({ type: GET_REGISTER_DETAIL_EXPO_BEGIN });

    const formdata = new FormData();
    if (categoryId !== undefined && categoryId !== null) {
      formdata.append("registration_category_id", categoryId);
    }

    axios
      .post(get_register_detail_expo_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_REGISTER_DETAIL_EXPO_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_REGISTER_DETAIL_EXPO_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Register Detail Expo Api ", err);
        dispatch({ type: GET_REGISTER_DETAIL_EXPO_ERROR });
      });
  };

  // ─── GET VISITOR FORMAT (POST with type) ───────────────────────────────────
  const GetVisitorFormat = async (typeId) => {
    dispatch({ type: GET_VISITOR_FORMAT_BEGIN });

    const formdata = new FormData();
    if (typeId !== undefined && typeId !== null) {
      formdata.append("type", typeId);
    }

    axios
      .post(visitor_format_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_VISITOR_FORMAT_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_VISITOR_FORMAT_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Visitor Format Api ", err);
        dispatch({ type: GET_VISITOR_FORMAT_ERROR });
      });
  };

  // ─── SUBMIT DOMESTIC VISITOR ───────────────────────────────────────────────────
  const PostDomesticForm = async (formdata) => {
    dispatch({ type: SUBMIT_DOMESTIC_VISITOR_BEGIN });

    return axios
      .post(submit_domestic_visitor_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: SUBMIT_DOMESTIC_VISITOR_SUCCESS });
          Notification(
            "success",
            "Success",
            res.data.message || "Message sent successfully!",
          );
          trackMetaPurchase();
          return true;
        } else {
          dispatch({ type: SUBMIT_DOMESTIC_VISITOR_ERROR });
          Notification(
            "error",
            "Error",
            res.data.message || "Something went wrong!",
          );
          return false;
        }
      })
      .catch((err) => {
        console.log("Error in PostDomesticForm Api ", err);
        dispatch({ type: SUBMIT_DOMESTIC_VISITOR_ERROR });
        Notification(
          "error",
          "Error",
          err?.data?.message || "Something went wrong!",
        );
        return false;
      });
  };
  // ─── SUBMIT INTERNATIONAL VISITOR ───────────────────────────────────────────────────
  const PostInternationalForm = async (formdata) => {
    dispatch({ type: SUBMIT_INTERNATIONAL_VISITOR_BEGIN });

    return axios
      .post(submit_international_visitor_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: SUBMIT_INTERNATIONAL_VISITOR_SUCCESS });
          Notification(
            "success",
            "Success",
            res.data.message || "Message sent successfully!",
          );
          trackMetaPurchase();
          return true;
        } else {
          dispatch({ type: SUBMIT_INTERNATIONAL_VISITOR_ERROR });
          Notification(
            "error",
            "Error",
            res.data.message || "Something went wrong!",
          );
          return false;
        }
      })
      .catch((err) => {
        console.log("Error in PostInternationalForm Api ", err);
        dispatch({ type: SUBMIT_INTERNATIONAL_VISITOR_ERROR });
        Notification(
          "error",
          "Error",
          err.response?.data?.message || err?.data?.message || "Something went wrong!",
        );
        return false;
      });
  };
  // ─── SUBMIT EXHIBITOR VISITOR ───────────────────────────────────────────────────
  const PostExhibitorForm = async (formdata) => {
    dispatch({ type: SUBMIT_EXHIBITOR_BEGIN });

    return axios
      .post(submit_exhibitor_visitor_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: SUBMIT_EXHIBITOR_SUCCESS });
          Notification(
            "success",
            "Success",
            res.data.message || "Message sent successfully!",
          );
          trackMetaPurchase();
          return true;
        } else {
          dispatch({ type: SUBMIT_EXHIBITOR_ERROR });
          Notification(
            "error",
            "Error",
            res.data.message || "Something went wrong!",
          );
          return false;
        }
      })
      .catch((err) => {
        console.log("Error in PostExhibitorForm Api ", err);
        dispatch({ type: SUBMIT_EXHIBITOR_ERROR });
        Notification(
          "error",
          "Error",
          err.response?.data?.message || err?.data?.message || "Something went wrong!",
        );
        return false;
      });
  };
  return (
    <FormContext.Provider
      value={{
        ...state,
        GetContactUs,
        PostExpoContactUs,
        GetRegisterForm,
        GetRegisterDetailExpo,
        GetVisitorFormat,
        PostDomesticForm,
        PostInternationalForm,
        PostExhibitorForm,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => {
  return useContext(FormContext);
};
